// extracted by mini-css-extract-plugin
export default {"layout":"IHK_o49dh2otXhpYo4NV","layoutLight":"nReXvQ2SjnU5U55jTGmg","bannerNotificationContainer":"Y_fuMI9AIxcJzJO9k8n1"};